import { render, staticRenderFns } from "./overtimeRules.vue?vue&type=template&id=38f22d06&"
import script from "./overtimeRules.vue?vue&type=script&lang=js&"
export * from "./overtimeRules.vue?vue&type=script&lang=js&"
import style0 from "./overtimeRules.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports